<template>
  <div>
    <v-dialog v-model="formDialog" max-width="800">
        <v-card class="popup-card" elevation="1">
          <v-card-title
            class="popupHeadline d-flex justify-center"
            style="font-size: 16px"
          >
            {{ $t('labels.addAdditionalCost') }}
          </v-card-title>

          <v-divider></v-divider>
          <ValidationObserver v-slot="{ handleSubmit, errors }" ref="observer">
            <v-card-text class="mt-2">
              <form @submit.prevent="handleSubmit(submitForm)">
                <v-row style="padding-bottom: 15px">
                  <FormElement
                    v-for="(element, index) in formElement"
                    :key="
                      element.key.parent + '_' + element.key.child + '_' + index
                    "
                    v-model="$data[element.key.parent][element.key.child]"
                    :validationLabel="$t(element.validationLabel)"
                    :rules="element.rules"
                    :formLabel="$t(element.formLabel)"
                    :onChange="element.onChange"
                    :formType="element.formType"
                    :lg="element.lg"
                    :cols="element.cols"
                    :hidden="element.hidden"
                    :labelShown="element.labelShown"
                    :topLabel="element.topLabel"
                    :active="element.active"
                    :placeholder="$t(element.placeholder)"
                    :willBeEliminated="false"
                    :classes="element.classes"
                    :fileStyling="element.fileStyling"
                  />
                </v-row>

                <v-card-actions class="d-flex justify-center">
                  <v-btn
                    style="
                      color: #fff;
                      text-transform: unset !important;
                      background-color: #0077d5;
                      padding: 2vh 3vh;
                      border-radius: 30px !important;
                      font-weight: bolder;
                      font-size: medium;
                    "
                    elevation="0"
                    class="darken-1"
                    type="submit"
                    color="primary"
                  >
                    {{
                      !isUpdate ? $t('buttons.add') : $t('buttons.update')
                    }}</v-btn
                  >
                  <v-btn
                    style="
                      color: #fff;
                      text-transform: unset !important;
                      background-color: var(--red);
                      padding: 2vh 2vh;
                      border-radius: 30px !important;
                      font-weight: bolder;
                      font-size: medium;
                    "
                    elevation="0"
                    class="darken-1"
                    @click="formDialog = false"
                    >{{ $t('buttons.cancel') }}</v-btn
                  >
                </v-card-actions>
              </form>
            </v-card-text>
          </ValidationObserver>
        </v-card>
      </v-dialog>
    <ConfirmationModal
      v-model="showConfirmDialog"
      :confirm="deleteItem"
      :title="$t('titles.warning')"
      :message="$t('description.deleteModalDescription')"
      :maxWidth="500"
      :onClose="
        () => {
          deleteItemId = null;
        }
      "
      :buttonSettings="{
        no: { text: $t('buttons.cancel') },
        yes: { text: $t('buttons.yes') },
      }"
    />
    <v-card
      elevation="1"
      class="mt-0 py-lg-10"
      style="margin: 0 !important; padding-right: 4%; padding-left: 4%"
    >
      <v-card-title class="popupHeadline">
        <v-row>
          <v-col class="text-left" lg="3" cols="12">
            <h5>{{ $t('navigationDrawerMenu.library') }}</h5>
          </v-col>
        </v-row>
        <v-tooltip bottom v-if="isAdmin">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-3"
              style="font-size: 32px"
              v-bind="attrs"
              v-on="on"
              @click="formDialog = true"
            >
              mdi-plus-box-outline
            </v-icon>
          </template>
          <span>{{ $t('buttons.add') }}</span>
        </v-tooltip>
        <RefreshButton :refreshFunction="getList"></RefreshButton>
      </v-card-title>
      <v-divider />

      <v-data-table
        :headers="headers"
        :items="list"
        :items-per-page="10"
        :options="{
          itemsPerPage: rowsPerPage,
        }"
        style="padding: 0 16px"
        hide-default-footer
        :loading="$store.state.loadingStatus"
        :no-data-text="$t('messages.noData')"
      >
        <template v-slot:item.actions="{ item }">
          <div class="text-start">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon :href="item.FilePath" download target="_blank">
                  <v-icon
                    small
                    color="success"
                    style="font-size: 20px"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-download-box
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('buttons.download') }}</span>
            </v-tooltip>
            <v-tooltip top v-if="isAdmin">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="updateItem(item)">
                  <v-icon
                    small
                    color="info"
                    style="font-size: 20px"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('buttons.update') }}</span>
            </v-tooltip>
            <v-tooltip top v-if="isAdmin">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="
                deleteItemId = item?.Id
                showConfirmDialog = true">
                  <v-icon
                    small
                    color="error"
                    style="font-size: 20px"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('buttons.delete') }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2 md4 lg4">
        <v-row align="center">
          <v-col md="3" class="ml-md-auto">
            <v-pagination
              v-if="pages > 0"
              @input="paginationChangeHandler"
              :value="page"
              :length="pages"
              :total-visible="10"
              circle
            ></v-pagination>
          </v-col>
          <v-col md="2" class="ml-md-auto">
            <v-select
              v-model="rowsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              outlined
              dense
              @change="changeItemsPerPage()"
              rounded
            >
            </v-select>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import RefreshButton from '../components/RefreshButton.vue';
import FormElement from '../components/FormElement.vue';
import SampleExcelServices from '../services/SampleExcelServices';
import uploadFile from '../utils/uploadFile.js';
import ConfirmationModal from '../components/General/ConfirmationModal.vue';

export default {
  data: () => ({
    deleteItemId: null,
    showConfirmDialog: false,

    formDialog: false,
    isUpdate: false,
    form: {
      Name: '',
      Description: '',
      FilePath: '',
      FileUri: '',
      DocRoletype: 0,
    },
    docRoleTypes: [],

    headers: [],
    itemsPerPageOptions: [],
    itemsPerPage: 10,
    page: 1,
    rowsPerPage: 15,
    perPageValues: [
      {
        name: '5',
        value: 5,
      },
      {
        name: '10',
        value: 10,
      },
      {
        name: '15',
        value: 15,
      },
      {
        name: '30',
        value: 30,
      },
      {
        name: '50',
        value: 50,
      },
      {
        name: '100',
        value: 100,
      },
    ],

    list: [],
  }),
  mounted() {
    this.docRoleTypes = [
      { Name: this.$t('labels.supplier'), Value: 0 },
      { Name: this.$t('labels.customer'), Value: 1 },
      { Name: this.$t('labels.All'), Value: 2 },
    ];

    this.headers = [
      {
        text: this.$t('labels.name'),
        value: 'Name',
        sortable: false,
        align: 'center',
      },
      {
        text: this.$t('labels.actions'),
        value: 'actions',
        sortable: false,
      },
    ];
    this.getList();
  },
  components: {
    RefreshButton,
    FormElement,
    ConfirmationModal
  },
  computed: {
    isSupplier(){
      const type = this.$store.state.Type;

      return type === 'Supplier' || type === 'PendingSupplier';
    },
    pages() {
      if (this.rowsPerPage == null || this.totalItems == null) {
        return 0;
      }
      return Math.ceil(this.totalItems / this.rowsPerPage);
    },

    isAdmin() {
      return this.$store.getters.getUserType === 'Admin';
    },

    formElement() {
      return [
        {
          key: {
            parent: 'form',
            child: 'Name',
          },
          rules: 'required',
          validationLabel: 'labels.name',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.name',
        },
        {
          key: {
            parent: 'form',
            child: 'Description',
          },
          validationLabel: 'labels.description',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'textarea',
          },
          lg: 12,
          cols: 12,
          placeholder: 'labels.description',
        },
        {
          key: {
            parent: 'form',
            child: 'File',
          },
          rules: this.isUpdate ? '' : 'required',
          validationLabel: 'labels.fileUpload',
          topLabel: true,
          labelShown: false,
          fileStyling: false,
          formType: {
            name: 'file',
            data: {
              accept: 'application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xlsx,.xls',
            },
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.fileUpload',
        },
        {
          key: {
            parent: 'form',
            child: 'DocRoletype',
          },
          rules: 'required',
          validationLabel: 'labels.fileType',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'select',
            items: {
              data: this.docRoleTypes,
              value: 'Value',
              text: 'Name',
            },
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.fileType',
        },
      ];
    },
  },
  methods: {
    deleteItem(){
      if(!this.deleteItemId) return;

      this.$store.state.loadingStatus = true;
      SampleExcelServices.delete(this.deleteItemId)
      .then(() => {
        this.getList()
        window.showSuccess(this.$t('messages.successfulDelete'))
      })
      .catch(window.showError)
      .finally(() => this.$store.state.loadingStatus = false)
    },

    updateItem(item){
      if(!item) return;

      this.form = Object.assign({ DocRoletype: item.ShipmentType }, item);
      this.isUpdate = true;
      this.formDialog = true;
    },

    onFileUpload(fileData){
      this.submitForm(fileData)
    },

    async submitForm(fileData = null){
      this.$store.state.loadingStatus = true;
      try{
        if(!fileData && this.form.File){
          const url = await uploadFile(this.form.File, this.onFileUpload, true)
          return;
        }
        
        const files = fileData?.Result;
        let file = null;
        if((Array.isArray(files) && files.length > 0)){
          file = files[0] || null;
        }

        const body = {
          "Name": this.form.Name,
          "Description": this.form.Description,
          "FilePath": file?.Url || this.form.FilePath,
          "FileUri": file?.s3Uri || this.form.FileUri,
          "DocRoletype": this.form.DocRoletype
        };

        if(this.isUpdate){
          body["Id"] = this.form?.Id;
        }

        await SampleExcelServices[this.isUpdate ? 'update' : 'add'](body);

        this.getList();
        this.formDialog = false;
        window.showSuccess(this.$t(`messages.${this.isUpdate ? 'changeFileSuccessful' : 'fileAddSuccess'}`))
      }
      catch(error){
        console.log(error);
        window.showError(error);
      }
      finally{
        this.$store.state.loadingStatus = false;
      }
    },

    getList() {
      this.$store.state.loadingStatus = true;
      SampleExcelServices.get({ page: this.page, pageSize: this.rowsPerPage, IsAdmin: this.isAdmin, DocRoletype: this.isSupplier ? 0 : 1 })
        .then((response) => {
          const data = response.data;
          if(data){
            this.list = data?.Result;
            this.totalItems = data?.TotalItems;
          }
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    changeItemsPerPage() {
      this.page = 1;
      this.getList();
    },
    paginationChangeHandler(pageNumber) {
      this.page = pageNumber;
      this.getList();
    },
  },
};
</script>
